import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'days-list',
  templateUrl: './days-list.component.html',
  styleUrls: ['./days-list.component.scss'],
  standalone: false,
})
export class DaysListComponent implements OnInit, OnDestroy {
  RESPONSIVE_BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
    xxl2: 1688,
    xxxl: 1920,
    xxxl2: 2560,
    xxxxl: 3440,
  } as const;

  @ViewChild('popOver') public popOver: NgbPopover;
  public today: Date = new Date(new Date().setHours(0, 0, 0, 0));

  @Input() public availabilityLabelText: string;
  @Input() public calendarLabelToday: string;
  @Input() public value: Date = new Date(this.today);

  @Output() public valueChange = new EventEmitter<Date>();

  @Input()
  get availableDays(): Date[] {
    return this._availableDays;
  }
  set availableDays(availableDays: Date[]) {
    this._availableDays = availableDays;
    this.daysListSetStartDate(this.value);
  }
  private _availableDays: Date[] = [];
  public calendarDateTitle: Date = new Date(this.today);

  //TBD calendarul nu te duce pe luna precedenta sau viitoare, se inchide !!!!!!!!!!!!
  public subscriptions: Subscription[] = [];

  public daysListLength: number;
  public daysList: Array<any> = [];

  constructor() {}

  ngOnInit(): void {
    this.daysListSetStartDate(this.value);

    // let subscription: Subscription = this._windowEventService.onResize.subscribe(() => {
    //   this.daysListSetStartDate(this.value);
    // });
    // this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  public getDaysList(startDate: Date, daysListLength: number): Array<any> {
    if (startDate === undefined) {
      startDate = this.today;
    }

    let daysArr: Array<any> = [];
    let date = new Date(startDate);
    for (let i = 0; i < daysListLength; i++) {
      daysArr.push({
        date: new Date(date),
        isAvailable: this.availableDays?.some(availableDay => availableDay.getTime() === date.getTime()),
      });
      date.setDate(date.getDate() + 1);
    }
    return daysArr;
  }

  public daysListSetStartDate(date: Date) {
    this.daysList = this.getDaysList(new Date(date.setHours(0, 0, 0, 0)), this.setDaysListLength());
    if (this.areAllDatesInSameMonth(this.daysList)) {
      this.calendarDateTitle = this.daysList[0].date;
    }
  }

  public areAllDatesInSameMonth(daysList: any[]): boolean {
    if (daysList.length === 0) {
      return false;
    }

    const firstMonth = daysList[0].date.getMonth();
    return daysList.every(day => day.date.getMonth() === firstMonth);
  }

  public onDaysListScroll(next: boolean) {
    const startDate = new Date(this.daysList[0].date);

    startDate.setDate(startDate.getDate() + (next ? 1 : startDate > this.today ? -1 : 0));
    this.daysListSetStartDate(startDate);
  }

  public onCalendarDateChange(date: Date) {
    this.onDayChange(date);
    this.daysListSetStartDate(date);
  }

  public onCalendarClick(event: MouseEvent) {
    const clickTarget = event.target as HTMLElement;
    if (clickTarget.classList.contains('k-calendar-td') || clickTarget.classList.contains('k-link')) {
      this.popOver.close();
    }
  }

  public setDaysListLength(): number {
    let daysListLength: number = 5;
    if (window.innerWidth < this.RESPONSIVE_BREAKPOINTS.sm) {
      daysListLength = 5;
    } else if (window.innerWidth < this.RESPONSIVE_BREAKPOINTS.xl) {
      daysListLength = 8;
    } else if (window.innerWidth < this.RESPONSIVE_BREAKPOINTS.xxxl) {
      daysListLength = 12;
    } else {
      daysListLength = 18;
    }
    return daysListLength;
  }

  onDayChange(date: Date) {
    this.calendarDateTitle = date;
    this.value = date;
    this.valueChange.emit(this.value);
  }

  public calendarDisabledDates = (date: Date): boolean => {
    return (
      date.getTime() < this.today.getTime() ||
      !this.availableDays?.some(availableDay => availableDay.getTime() === date.getTime())
    );
  };
}
